import React from "react";
import Dashboard from "@/App";

export default function AppDashboard() {
  return <Dashboard />;
}
